import i18n from "config/i18next";

i18n.addResources("es", "filterSlots", {
  regionLabel: "Región",
  regionPlaceholder: "Seleccioná la región",
  workzoneLabel: "Zona de operación",
  workzonePlaceholder: "Seleccioná la zona",
  dateLabel: "Fecha *",
  datePlaceholder: "Seleccioná la fecha",
  statusLabel: "Estados",
  statusPlaceholder: "Seleccioná los estados",
  shiftLabel: "Horario",
  shiftPlaceholder: "Seleccioná el turno",
});
